import { Injectable } from '@angular/core';
import { CanActivate, CanLoad } from '@angular/router';
import { NavigationSlugs } from '../../navigation/navigation-slugs';
import { NavigationService } from '../../navigation/navigation.service';
import { AppNotificationService } from '@core/services/app-notification.service';
import { TranslationService } from '@core/translation/translation.service';
import { TolgeeService } from '@core/translation/tolgee.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../../auth/auth.service';
import { canAccessU2bAdminArea } from '@modules/admin/tenants/utils/admin-u2b-realm-access.util';

@Injectable()
export class U2bAdminAuthGuard implements CanLoad, CanActivate {
    constructor(
        private authService: AuthService,
        private navigationService: NavigationService,
        private appNotificationService: AppNotificationService,
        private tolgeeService: TolgeeService,
    ) {
    }

    canLoad(): Observable<boolean> {
        return this.isAccessAllowed();
    }

    canActivate(): Observable<boolean> {
        return this.isAccessAllowed();
    }

    isAccessAllowed(): Observable<boolean> {
        return this.authService
            .userData$
            .pipe(map(userData => {
                const roles = userData?.groups || [];
                const result = canAccessU2bAdminArea(roles);

                if (result) {
                    // Admin-UI ist mandantenübergreifend — Default-Namespace statt tenant_override.
                    this.tolgeeService.resetTenant();
                    this.navigationService.changeNavigationTo(NavigationSlugs.MainAdmin);
                } else {
                    this.appNotificationService.showError(TranslationService.translate('admin.error.accessDenied'));
                }

                return result;
            }));
    }
}
